import React from 'react';
import { useLanguage } from "../Services/ContextProvider/LanguageContextProvider";

function SessionError() {
  const { t } = useLanguage();
  return (
    <div className="session-error">
      <div className="session-error-txt">
        {t("It looks like this session has timed out. Please reopen Ask Ralph through the For You tab and start a new chat for more.")}
      </div>
    </div>
  )
}

export default SessionError
